import React from 'react';
import cn from 'classname';

import find from 'lodash/find';
import sumBy from 'lodash/sumBy';

import { connect } from 'react-redux';

import { Link } from 'react-router';

import FormattedDate from '../../../components/formatted-date';
import EventCount from '../../../components/event-count';

import withCheckPermission from '../../../../shared/check-permission-hoc';

import { enum as permissions } from '../../../../../../../../enums/admin-permissions';
import { enum as mailingTypes } from '../../../../../../../../enums/mailing-types';
import { enum as mailingEvents } from '../../../../../../../../enums/mailing-events';

const type = mailingTypes.triggered;

function MailingRow({ className, mailing, check, onClick, removeBySplitTestId, ...props }) {
	const event = find(props.notificationEventTypes, { id: mailing.event }) || {};

	const reach = sumBy(mailing.list, 'reach');
	const mailings = mailing.list.map(t => t.id);

	return (
		<tr
			className={cn('new-table__body__item', className)}
			onClick={onClick}
		>
			<td>
				<FormattedDate date={mailing.created_at} />
			</td>
			<td>
				{event.text}
			</td>
			<td>
				<span
					className={`flag-icon flag-icon-${mailing.language}`}
					title={mailing.language}
				/>
			</td>
			<td>
				{mailing.list.map((template) => (
					<div key={template.id}>{template.title}</div>
				))}
			</td>
			<td />
			<td>
				{reach}
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.open}
					isAtLeastOneUniqueEvent={!!sumBy(mailing.list, 'unique_opens')}
					reach={reach}
					count={sumBy(mailing.list, 'opens')}
				/>
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.click}
					isAtLeastOneUniqueEvent={!!sumBy(mailing.list, 'unique_clicks')}
					reach={reach}
					count={sumBy(mailing.list, 'clicks')}
				/>
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.bounce}
					isAtLeastOneUniqueEvent={!!sumBy(mailing.list, 'unique_bounces')}
					reach={reach}
					count={sumBy(mailing.list, 'bounces')}
				/>
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.unsub}
					isAtLeastOneUniqueEvent={!!sumBy(mailing.list, 'unique_unsubs')}
					reach={reach}
					count={sumBy(mailing.list, 'unsubs')}
				/>
			</td>
			<td>
				<div className='action-list'>
					<Link
						className={check(permissions.mailingsCreate) ? 'banners-edit-icon' : 'view-icon'}
						to={`/mailings-new/triggered-mailings/${mailing.split_test_id}/editor`}
					/>
					{check(permissions.mailingsDelete) && (
						<a
							className='remove-icon'
							onClick={(e) => {
								e.stopPropagation();
								removeBySplitTestId(mailing.split_test_id);
							}}
						/>
					)}
				</div>
			</td>
		</tr>
	);
}

function mapStateToProps(state) {
	return {
		notificationEventTypes: state.root.lists['notification-event-types']
	};
}

export default connect(mapStateToProps)(withCheckPermission(MailingRow));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/triggered-mailings/list/components/mailing-row.js